export default __webpack_public_path__ + "4051809302184accc95002d3a3dced30.png";